import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4" data-id="element-66">
      {items.map((item, index) => <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden border border-[#E8B4B8]/20" data-id="element-67">
          <button onClick={() => toggleItem(index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-[#FFF8F0] transition-colors" aria-expanded={openIndex === index} data-id="element-68">
            <span className="font-['Crimson_Text'] text-lg font-semibold text-[#3A3A3A]" data-id="element-69">
              {item.question}
            </span>
            <ChevronDownIcon className={`w-5 h-5 text-[#A8C5A8] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" />
          </button>
          <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-71">
            <div className="px-6 pb-4 text-[#5A5A5A] leading-relaxed" data-id="element-72">
              {item.answer}
            </div>
          </div>
        </div>)}
    </div>;
}